"use strict";
/**
 * @module Shapes
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 图形
 */
var PathShape_1 = require("./PathShape");
var R_1 = require("../R");
var planimetry_1 = require("../planimetry");
/**
 * 多边形
 */
var PloygonShape = /** @class */ (function (_super) {
    __extends(PloygonShape, _super);
    function PloygonShape() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * 是否填充该多边形
         */
        _this.isFilled = false;
        _this.render = function (ctx) {
            R_1.putPath(_this.paths, true)(ctx);
            if (_this.isFilled) {
                ctx.fill();
            }
        };
        return _this;
    }
    PloygonShape.prototype.inRegion = function (p) {
        return planimetry_1.isInPolygon(this.paths, p);
    };
    return PloygonShape;
}(PathShape_1.PathShape));
exports.PloygonShape = PloygonShape;
//# sourceMappingURL=PloygonShape.js.map